// Dependencies
import { Component } from 'react';
import { connect } from 'react-redux';

import { TIME_MODE_RANG_HOURS } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { InterfaceVariablesType, Layout, PortShipType, PortType, RootState, SwitchType, UserType } from 'types';
import { MainControlsInterface, MapControlsInterface } from 'types/functions';
import { FilterObjectType } from 'types/search';
import { SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, checkLayoutDifferent, clone, getId } from 'utils/formHandlers';
import { twclsx } from 'utils/twclsx';

import { translate } from 'utils/translate';
import HighlightTab from './tabs/HighlightTab';

interface HighlightMenuComponentProps {
    layout: Layout;
    active: boolean;

    setLayoutAction: SetLayoutAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    port: PortType;

    mode: string;
    system: SystemType;
    switchs: SwitchType;
    dateTimeFormat: DateTimeFormat;
    mapControls: MapControlsInterface;
    user: UserType;

    mainControls: MainControlsInterface;
    searchObject: FilterObjectType;
    highlightObject: FilterObjectType;
}

interface HighlightMenuComponentState {
    layout: Layout;
    active: boolean;
    switchs: SwitchType;

    startTime: DateTimeFormat;
    endTime: DateTimeFormat;
    interfaceVariables: InterfaceVariablesType;
    selectedTime?: DateTimeFormat | null;
    tracks: any[];
    portShips?: PortShipType[];
    transitShips?: PortShipType[];
    minimumLength: number;
    mode: string;
    system: SystemType;
    groups: {
        id: string;
        name: string;
        active: boolean;
        total: number;
        display?: boolean;
        trackLoaded?: boolean;
        drawTrack?: boolean;
    }[];

    searchId: string;
    searchObject: FilterObjectType;
    highlightObject: FilterObjectType;
}

class HighlightMenu extends Component<HighlightMenuComponentProps, HighlightMenuComponentState> {
    constructor(props: HighlightMenuComponentProps) {
        super(props);
        this.state = {
            layout: clone(props.layout),
            switchs: clone(props.switchs),
            interfaceVariables: props.port.meta_data.interfaceVariables,

            active: props.active,
            system: props.system,
            mode: '',
            portShips: props.port.port_ships,
            transitShips: props.port.transit_ships,
            minimumLength: props.port.minimum_length | 40,
            tracks: [],
            startTime: props.system.date.today.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
            endTime: props.system.date.today.clone(),
            selectedTime: props.system.date.today.clone().minus({ minutes: 10 }),
            groups: [
                { name: 'transitVessels', id: getId(), active: true, total: 0 },
                { name: 'portVessels', id: getId(), active: false, total: 0 },
                { name: 'otherVessels', id: getId(), active: false, total: 0 },
            ],
            searchId: '',
            searchObject: props.searchObject,
            highlightObject: props.highlightObject,
        };
    }

    static getDerivedStateFromProps(props: HighlightMenuComponentProps, state: HighlightMenuComponentState) {
        if (checkDifferent(props.searchObject, state.searchObject) || props.active !== state.active) {
            return {
                searchObject: props.searchObject,
                active: props.active,
                searchId: props.layout.searchId,
            };
        }

        if (
            checkDifferent(props.highlightObject, state.highlightObject) ||
            props.active !== state.active ||
            checkLayoutDifferent(props.layout, state.layout, ['sections.grid.menus.highlightMenu', 'searchId'])
        ) {
            return {
                highlightObject: props.highlightObject,
                active: props.active,
                searchId: props.layout.searchId,
                layout: clone(props.layout),
            };
        }

        return null;
    }

    changeTab = (tab: string) => {
        if (!this.state.layout.sections.grid.menus.highlightMenu.sections[tab].state) {
            return;
        }

        this.props.setLayoutAction([
            {
                action: 'UPDATE_MENU_SECTION',
                data: {
                    menu: 'highlightMenu',
                    section: 'grid',
                    name: tab,
                    state: true,
                    selected: true,
                },
            },
        ]);
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-smallMenu',
                    'ml-subMenu',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between py-3  px-2">
                    <div className="text-lg font-bold">{translate('highlight transits')}</div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'highlightMenu',
                                        section: 'grid',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'highlightMenu',
                                        section: 'chart',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'highlightMenu',
                                        section: 'profile',
                                        state: false,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div> */}
                </div>
                {/* <div className="flex justify-between  py-3  px-2">
                    <div className="text-lg font-bold">{translate(this.state.layout.sections.grid.label)}</div>
                    <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'highlightMenu',
                                        section: 'grid',
                                        state: !this.state.layout.sections.grid.menus.highlightMenu.state,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path d="M15 6l-6 6l6 6"></path>
                        </Icon>
                    </div>
                </div> */}
                {/* <div className="flex border-y border-gray-300">
                    <div
                        onClick={() => {
                            this.changeTab('search');
                        }}
                        className={twclsx(
                            this.state.layout.sections.grid.menus.highlightMenu.sections.search.selected && 'bg-gray-200',
                            this.state.layout.sections.grid.menus.highlightMenu.sections.search.state && 'hover:bg-gray-200',
                            'flex-1',
                            !this.state.layout.sections.grid.menus.highlightMenu.sections.search.state && 'text-gray-500',
                            'cursor-pointer',
                            'text-center',
                            'px-4',
                            'py-2',
                            'font-bold',
                            'border-r',
                            'border-gray-300'
                        )}
                    >
                        {translate('search')}
                    </div>
                    <div
                        onClick={() => {
                            this.changeTab('highlight');
                        }}
                        className={twclsx(
                            this.state.layout.sections.grid.menus.highlightMenu.sections.highlight.selected && 'bg-gray-200',
                            this.state.layout.sections.grid.menus.highlightMenu.sections.highlight.state &&
                                'hover:bg-gray-200',
                            'flex-1',
                            'cursor-pointer',
                            !this.state.layout.sections.grid.menus.highlightMenu.sections.highlight.state && 'text-gray-500',
                            'text-center',
                            'px-4',
                            'py-2',
                            'font-bold'
                        )}
                    >
                        {translate('highlight')}
                    </div>
                </div> */}
                <div>
                    {/* <SearchTab
                        active={this.state.layout.sections.grid.menus.highlightMenu.sections.search.selected}
                        searchObject={this.state.searchObject}
                        searchId={this.state.searchId}
                    ></SearchTab> */}

                    <HighlightTab
                        active={this.props.active}
                        searchObject={this.state.searchObject}
                        highlightObject={this.state.highlightObject}
                    ></HighlightTab>
                </div>
            </div>
        );
    }
}

const highlightMenuStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    system: state.port.system,
    switchs: state.layout.switchs,
    mapControls: state.map.mapControls,
    mode: state.layout.mode,
    user: state.user.user,
    mainControls: state.layout.mainControls,
    searchObject: state.layout.searchObject,
    highlightObject: state.layout.highlightObject,
});

const highlightMenuDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(highlightMenuStateToProps, highlightMenuDispatchToProps)(HighlightMenu);
